import BaseApi from './BaseApi';

export interface IClone {
    clone(context: string, options: string, jwt: string): Promise<object>;
}

export default class Clone extends BaseApi implements IClone {
    constructor(baseUrl: string) {
        super(baseUrl);
    }

    public clone = (context: string, options: string, jwt: string) => {
        return this.postRequest(`${this.baseUrl}v1.0/clone-data`, { context, options }, jwt);
    };
}



// WEBPACK FOOTER //
// ./src/api/Clone.ts